import { render, staticRenderFns } from "./OrderNotesDetailsAndForm.vue?vue&type=template&id=6b9a72c1&scoped=true"
import script from "./OrderNotesDetailsAndForm.vue?vue&type=script&lang=ts"
export * from "./OrderNotesDetailsAndForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderNotesDetailsAndForm.vue?vue&type=style&index=0&id=6b9a72c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a72c1",
  null
  
)

export default component.exports